/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState, useEffect, useCallback } from "react";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Fade from "@material-ui/core/Fade";

import { Text } from "UpduoLibrary";
import { skaleDeactiveGray, skaleWebTextGray } from "config/UpduoColors";

export default function ExploreFilter({
  value,
  primaryText,
  onChange,
  optionList,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [text, setText] = useState(primaryText);
  const [allMenuItems, setAllMenuItems] = useState<Object[]>([]);

  useEffect(() => {
    if (value) {
      for (let i = 0; i < optionList.length; i++) {
        if (value === optionList[i].id) {
          setText(optionList[i].name);
          break;
        } else {
          setText(primaryText);
        }
      }
    } else {
      setText(primaryText);
    }
  }, [value, primaryText, optionList]);

  const _handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const _handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const _handleChange = useCallback(
    (id, text) => {
      onChange(id);
      setText(text);
      _handleClose();
    },
    [_handleClose, onChange]
  );

  const _handleGenerateMenuItem = useCallback(
    (key, id, text) => {
      return (
        <MenuItem
          key={key}
          value={id}
          style={{
            color: skaleWebTextGray,
            fontSize: 14,
            fontFamily: "ObjectSans-Regular",
          }}
          onClick={() => {
            _handleChange(id, text);
          }}
        >
          {text}
        </MenuItem>
      );
    },
    [_handleChange]
  );

  const _handleGenerateOptions = useCallback(() => {
    const allOptions: Object[] = [];
    allOptions.push(
      <MenuItem
        value={undefined}
        onClick={() => {
          _handleChange(null, primaryText);
        }}
        style={{
          color: skaleWebTextGray,
          fontFamily: "ObjectSans-Regular",
          fontSize: 14,
        }}
        key={0}
      >
        {primaryText}
      </MenuItem>
    );
    let key = 1;
    let id = null;
    let text = null;
    for (let i = 0; i < optionList.length; i++) {
      if (primaryText !== "All Lessons" || optionList[i].is_active) {
        id = optionList[i].id;
        text = optionList[i].name;
        allOptions.push(_handleGenerateMenuItem(key, id, text));
        key++;
      }
    }
    setAllMenuItems(allOptions);
  }, [_handleGenerateMenuItem, _handleChange, primaryText, optionList]);

  useEffect(() => {
    _handleGenerateOptions();
  }, [optionList, _handleGenerateOptions]);

  return (
    <React.Fragment>
      <ButtonBase
        aria-controls={"fade-menu"}
        aria-haspopup={"true"}
        onClick={_handleClick}
        style={{
          color: skaleWebTextGray,
          marginTop: 20,
          fontFamily: "ObjectSans-Regular",
          marginRight: 26,
          padding: 8,
        }}
      >
        <Text style={{ color: skaleDeactiveGray, fontSize: 14 }}>{text}</Text>
      </ButtonBase>
      <Menu
        id={"fade-menu"}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={_handleClose}
        TransitionComponent={Fade}
        style={{ marginLeft: -8.5 }}
      >
        {allMenuItems}
      </Menu>
    </React.Fragment>
  );
}
